import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _dec2, _dec3, _dec4, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _BookmarkModal_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
/* import __COLOCATED_TEMPLATE__ from './bookmark.hbs'; */
import Component from "@glimmer/component";
import { tracked } from "@glimmer/tracking";
import { action } from "@ember/object";
import { and, notEmpty } from "@ember/object/computed";
import { service } from "@ember/service";
import ItsATrap from "@discourse/itsatrap";
import { Promise } from "rsvp";
import { CLOSE_INITIATED_BY_CLICK_OUTSIDE } from "discourse/components/d-modal";
import { extractError } from "discourse/lib/ajax-error";
import { formattedReminderTime } from "discourse/lib/bookmark";
import KeyboardShortcuts from "discourse/lib/keyboard-shortcuts";
import { sanitize } from "discourse/lib/text";
import { defaultTimeShortcuts, TIME_SHORTCUT_TYPES } from "discourse/lib/time-shortcut";
import { now, parseCustomDatetime, startOfDay } from "discourse/lib/time-utils";
import { AUTO_DELETE_PREFERENCES } from "discourse/models/bookmark";
import discourseLater from "discourse-common/lib/later";
import I18n from "discourse-i18n";
import TEMPLATE from "./bookmark.hbs";
import { setComponentTemplate } from "@ember/component";
const BOOKMARK_BINDINGS = {
  enter: {
    handler: "saveAndClose"
  },
  "d d": {
    handler: "delete"
  }
};
let BookmarkModal = (_dec = notEmpty("userTimezone"), _dec2 = notEmpty("bookmark.id"), _dec3 = notEmpty("bookmark.id"), _dec4 = and("bookmark.id", "bookmark.reminderAt"), (_class = (_BookmarkModal_brand = /*#__PURE__*/new WeakSet(), class BookmarkModal extends Component {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _BookmarkModal_brand);
    _initializerDefineProperty(this, "dialog", _descriptor, this);
    _initializerDefineProperty(this, "currentUser", _descriptor2, this);
    _initializerDefineProperty(this, "site", _descriptor3, this);
    _initializerDefineProperty(this, "bookmarkApi", _descriptor4, this);
    _initializerDefineProperty(this, "postDetectedLocalDate", _descriptor5, this);
    _initializerDefineProperty(this, "postDetectedLocalTime", _descriptor6, this);
    _initializerDefineProperty(this, "postDetectedLocalTimezone", _descriptor7, this);
    _initializerDefineProperty(this, "prefilledDatetime", _descriptor8, this);
    _initializerDefineProperty(this, "flash", _descriptor9, this);
    _initializerDefineProperty(this, "userTimezone", _descriptor10, this);
    _initializerDefineProperty(this, "showOptions", _descriptor11, this);
    _initializerDefineProperty(this, "userHasTimezoneSet", _descriptor12, this);
    _initializerDefineProperty(this, "showDelete", _descriptor13, this);
    _initializerDefineProperty(this, "editingExistingBookmark", _descriptor14, this);
    _initializerDefineProperty(this, "existingBookmarkHasReminder", _descriptor15, this);
    _initializerDefineProperty(this, "_closeWithoutSaving", _descriptor16, this);
    _initializerDefineProperty(this, "_savingBookmarkManually", _descriptor17, this);
    _initializerDefineProperty(this, "_saving", _descriptor18, this);
    _initializerDefineProperty(this, "_deleting", _descriptor19, this);
    _defineProperty(this, "_itsatrap", new ItsATrap());
  }
  get bookmark() {
    return this.args.model.bookmark;
  }
  get modalTitle() {
    return I18n.t(this.bookmark.id ? "bookmarks.edit" : "bookmarks.create");
  }
  get autoDeletePreferences() {
    return Object.keys(AUTO_DELETE_PREFERENCES).map(key => {
      return {
        id: AUTO_DELETE_PREFERENCES[key],
        name: I18n.t(`bookmarks.auto_delete_preference.${key.toLowerCase()}`)
      };
    });
  }
  get showExistingReminderAt() {
    return this.bookmark.reminderAt && Date.parse(this.bookmark.reminderAt) > new Date().getTime();
  }
  get existingReminderAtFormatted() {
    return formattedReminderTime(this.bookmark.reminderAt, this.userTimezone);
  }
  get timeOptions() {
    const options = defaultTimeShortcuts(this.userTimezone);
    if (this.showPostLocalDate) {
      options.push({
        icon: "globe-americas",
        id: TIME_SHORTCUT_TYPES.POST_LOCAL_DATE,
        label: "time_shortcut.post_local_date",
        time: _assertClassBrand(_BookmarkModal_brand, this, _parsedPostLocalDateTime).call(this),
        timeFormatKey: "dates.long_no_year",
        hidden: false
      });
    }
    return options;
  }
  get showPostLocalDate() {
    if (!this.postDetectedLocalTime || !this.postDetectedLocalDate) {
      return false;
    }
    if (_assertClassBrand(_BookmarkModal_brand, this, _parsedPostLocalDateTime).call(this) < now(this.userTimezone)) {
      return false;
    }
    return true;
  }
  get hiddenTimeShortcutOptions() {
    if (this.editingExistingBookmark && !this.existingBookmarkHasReminder) {
      return [TIME_SHORTCUT_TYPES.NONE];
    }
    return [];
  }
  get customTimeShortcutLabels() {
    const labels = {};
    if (this.existingBookmarkHasReminder) {
      labels[TIME_SHORTCUT_TYPES.NONE] = "bookmarks.remove_reminder_keep_bookmark";
    }
    return labels;
  }
  willDestroy() {
    super.willDestroy(...arguments);
    this._itsatrap?.destroy();
    this._itsatrap = null;
    KeyboardShortcuts.unpause();
  }
  didInsert() {
    discourseLater(() => {
      if (this.site.isMobileDevice) {
        document.getElementById("bookmark-name").blur();
      }
    });
    if (!this.args.model.bookmark.id) {
      document.getElementById("tap_tile_none").classList.add("active");
    }
    _assertClassBrand(_BookmarkModal_brand, this, _bindKeyboardShortcuts).call(this);
    _assertClassBrand(_BookmarkModal_brand, this, _initializeExistingBookmarkData).call(this);
    _assertClassBrand(_BookmarkModal_brand, this, _loadPostLocalDates).call(this);
  }
  saveAndClose() {
    this.flash = null;
    if (this._saving || this._deleting) {
      return;
    }
    this._saving = true;
    this._savingBookmarkManually = true;
    return _assertClassBrand(_BookmarkModal_brand, this, _saveBookmark).call(this).then(() => this.args.closeModal()).catch(error => _assertClassBrand(_BookmarkModal_brand, this, _handleSaveError).call(this, error)).finally(() => {
      this._saving = false;
    });
  }
  toggleShowOptions() {
    this.showOptions = !this.showOptions;
  }
  onTimeSelected(type, time) {
    this.bookmark.selectedReminderType = type;
    this.bookmark.selectedDatetime = time;
    this.bookmark.reminderAt = time;

    // If the type is custom, we need to wait for the user to click save, as
    // they could still be adjusting the date and time
    if (![TIME_SHORTCUT_TYPES.CUSTOM, TIME_SHORTCUT_TYPES.RELATIVE].includes(type)) {
      return this.saveAndClose();
    }
  }
  closingModal(closeModalArgs) {
    // If the user clicks outside the modal we save automatically for them,
    // as long as they are not already saving manually or deleting the bookmark.
    if (closeModalArgs.initiatedBy === CLOSE_INITIATED_BY_CLICK_OUTSIDE && !this._closeWithoutSaving && !this._savingBookmarkManually) {
      _assertClassBrand(_BookmarkModal_brand, this, _saveBookmark).call(this).catch(e => _assertClassBrand(_BookmarkModal_brand, this, _handleSaveError).call(this, e)).then(() => {
        this.args.closeModal(closeModalArgs);
      });
    } else {
      this.args.closeModal(closeModalArgs);
    }
  }
  closeWithoutSavingBookmark() {
    this._closeWithoutSaving = true;
    this.args.closeModal({
      closeWithoutSaving: this._closeWithoutSaving
    });
  }
  delete() {
    if (!this.bookmark.id) {
      return;
    }
    this._deleting = true;
    const deleteAction = () => {
      this._closeWithoutSaving = true;
      _assertClassBrand(_BookmarkModal_brand, this, _deleteBookmark).call(this).then(() => {
        this._deleting = false;
        this.args.closeModal({
          closeWithoutSaving: this._closeWithoutSaving
        });
      }).catch(error => _assertClassBrand(_BookmarkModal_brand, this, _handleSaveError).call(this, error));
    };
    if (this.existingBookmarkHasReminder) {
      this.dialog.deleteConfirm({
        message: I18n.t("bookmarks.confirm_delete"),
        didConfirm: () => deleteAction()
      });
    } else {
      deleteAction();
    }
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "dialog", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "currentUser", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "site", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "bookmarkApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "postDetectedLocalDate", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "postDetectedLocalTime", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "postDetectedLocalTimezone", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "prefilledDatetime", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "flash", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "userTimezone", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.currentUser.user_option.timezone;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "showOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return this.args.model.bookmark.id ? true : false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "userHasTimezoneSet", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "showDelete", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "editingExistingBookmark", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "existingBookmarkHasReminder", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_closeWithoutSaving", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_savingBookmarkManually", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_saving", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_deleting", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _applyDecoratedDescriptor(_class.prototype, "didInsert", [action], Object.getOwnPropertyDescriptor(_class.prototype, "didInsert"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "saveAndClose", [action], Object.getOwnPropertyDescriptor(_class.prototype, "saveAndClose"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "toggleShowOptions", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleShowOptions"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onTimeSelected", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onTimeSelected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closingModal", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closingModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "closeWithoutSavingBookmark", [action], Object.getOwnPropertyDescriptor(_class.prototype, "closeWithoutSavingBookmark"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "delete", [action], Object.getOwnPropertyDescriptor(_class.prototype, "delete"), _class.prototype)), _class));
function _parsedPostLocalDateTime() {
  let parsedPostLocalDate = parseCustomDatetime(this.postDetectedLocalDate, this.postDetectedLocalTime, this.userTimezone, this.postDetectedLocalTimezone);
  if (!this.postDetectedLocalTime) {
    return startOfDay(parsedPostLocalDate);
  }
  return parsedPostLocalDate;
}
function _saveBookmark() {
  if (this.bookmark.selectedReminderType === TIME_SHORTCUT_TYPES.CUSTOM) {
    if (!this.bookmark.reminderAtISO) {
      return Promise.reject(I18n.t("bookmarks.invalid_custom_datetime"));
    }
  }
  if (this.editingExistingBookmark) {
    return this.bookmarkApi.update(this.bookmark).then(() => {
      this.args.model.afterSave?.(this.bookmark);
    });
  } else {
    return this.bookmarkApi.create(this.bookmark).then(() => {
      this.args.model.afterSave?.(this.bookmark);
    });
  }
}
function _deleteBookmark() {
  return this.bookmarkApi.delete(this.bookmark.id).then(response => {
    this.args.model.afterDelete?.(response, this.bookmark.id);
  });
}
function _handleSaveError(error) {
  this._savingBookmarkManually = false;
  if (typeof error === "string") {
    this.flash = sanitize(error);
  } else {
    this.flash = sanitize(extractError(error));
  }
}
function _bindKeyboardShortcuts() {
  KeyboardShortcuts.pause();
  Object.keys(BOOKMARK_BINDINGS).forEach(shortcut => {
    this._itsatrap.bind(shortcut, () => {
      const binding = BOOKMARK_BINDINGS[shortcut];
      this[binding.handler]();
      return false;
    });
  });
}
function _initializeExistingBookmarkData() {
  if (!this.existingBookmarkHasReminder || !this.editingExistingBookmark) {
    return;
  }
  this.prefilledDatetime = this.bookmark.reminderAt;
  this.bookmark.selectedDatetime = parseCustomDatetime(this.prefilledDatetime, null, this.userTimezone);
}
// If we detect we are bookmarking a post which has local-date data
// in it, we can preload that date + time into the form to use as the
// bookmark reminder date + time.
function _loadPostLocalDates() {
  if (this.bookmark.bookmarkableType !== "Post") {
    return;
  }
  const postEl = document.querySelector(`[data-post-id="${this.bookmark.bookmarkableId}"]`);
  const localDateEl = postEl?.querySelector(".discourse-local-date");
  if (localDateEl) {
    this.postDetectedLocalDate = localDateEl.dataset.date;
    this.postDetectedLocalTime = localDateEl.dataset.time;
    this.postDetectedLocalTimezone = localDateEl.dataset.timezone;
  }
}
export { BookmarkModal as default };
setComponentTemplate(TEMPLATE, BookmarkModal);